import React, { useEffect, useState } from 'react';
import { heroData, images } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToNext = () => {
    const element = document.querySelector('#philosophy');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {/* Parallax Background Layers */}
      <div className="absolute inset-0">
        {/* Layer 3 - Furthest back */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${images.heroParallax[0]})`,
            transform: `translateY(${scrollY * 0.5}px) scale(1.1)`,
            filter: 'brightness(0.4)'
          }}
        />
        {/* Layer 2 - Middle */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${images.heroParallax[1]})`,
            transform: `translateY(${scrollY * 0.3}px)`,
            opacity: 0.3,
            mixBlendMode: 'overlay'
          }}
        />
        {/* Layer 1 - Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to bottom, rgba(26, 43, 60, 0.6) 0%, rgba(26, 43, 60, 0.8) 50%, rgba(26, 43, 60, 0.95) 100%)',
            transform: `translateY(${scrollY * 0.1}px)`
          }}
        />
      </div>

      {/* Gold accent elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-60" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-40" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6">
        <div className="max-w-4xl mx-auto text-center">
          {/* Decorative element */}
          <div className="flex items-center justify-center gap-4 mb-8 animate-fade-in">
            <div className="w-16 h-px bg-[#D4AF37]" />
            <div className="w-3 h-3 border border-[#D4AF37] rotate-45" />
            <div className="w-16 h-px bg-[#D4AF37]" />
          </div>

          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight animate-fade-in-up">
            {heroData.headline}
          </h1>

          <p className="font-lato text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed animate-fade-in-up animation-delay-200">
            {heroData.subheadline}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-400">
            <button className="book-tour-btn font-lato px-8 py-4 bg-[#D4AF37] text-[#1A2B3C] rounded hover:bg-[#D4AF37]/90 transition-all duration-300 font-semibold tracking-wide text-lg">
              {heroData.primaryCTA}
            </button>
            <button className="font-lato px-8 py-4 border-2 border-white/40 text-white rounded hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 tracking-wide">
              {heroData.secondaryCTA}
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <button
          onClick={scrollToNext}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 text-[#D4AF37] animate-bounce cursor-pointer"
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
